"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _UserProfile = _interopRequireDefault(require("MeetingsBase/models/UserProfile"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UIErrorMessage = _interopRequireDefault(require("UIComponents/error/UIErrorMessage"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H4"));

var _errors = require("MeetingsLib/constants/errors");

var _utils = require("MeetingsLib/utils/utils");

var _default = (0, _createReactClass.default)({
  displayName: "Error",
  propTypes: {
    meetingCreationFailed: _propTypes.default.bool.isRequired,
    profile: _propTypes.default.instanceOf(_UserProfile.default),
    bookInfoFailed: _propTypes.default.bool,
    bookInfoError: _propTypes.default.string,
    meetingsUserFetchSuccess: _propTypes.default.bool,
    onFailure: _propTypes.default.func,
    NotFoundMarker: _propTypes.default.func.isRequired,
    ErrorMarker: _propTypes.default.func.isRequired
  },
  componentDidMount: function componentDidMount() {
    if (this.props.meetingCreationFailed) {
      this.props.onFailure();
    }
  },
  handleReloadPage: function handleReloadPage() {
    document.location.reload(true);
  },
  renderDescription: function renderDescription(message) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return _react.default.createElement("p", {
      className: "error-description",
      key: "description"
    }, _react.default.createElement(_FormattedHTMLMessage.default, {
      message: message,
      options: options
    }));
  },
  renderEmail: function renderEmail() {
    var profile = this.props.profile;
    return _react.default.createElement("div", {
      className: "error-email",
      key: "email"
    }, _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "error.email",
      options: {
        fullName: (0, _utils.getLongDisplayName)(profile)
      }
    }), _react.default.createElement(_UILink.default, {
      href: "mailto:" + profile.email
    }, profile.email));
  },
  renderRetryButton: function renderRetryButton() {
    return _react.default.createElement("div", {
      className: "error-button-container",
      key: "retry"
    }, _react.default.createElement(_UIButton.default, {
      use: "tertiary",
      className: "error-button",
      onClick: this.handleReloadPage
    }, _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "error.button"
    })));
  },
  renderHeader: function renderHeader(message) {
    return _react.default.createElement(_H.default, {
      className: "m-bottom-2",
      key: "header"
    }, _react.default.createElement(_FormattedHTMLMessage.default, {
      message: message
    }));
  },
  renderCreateErrorWithReload: function renderCreateErrorWithReload() {
    return _react.default.createElement(_UIErrorMessage.default, {
      title: this.renderHeader('error.general.header')
    }, this.renderDescription('error.general.retryDescription'), this.renderRetryButton(), this.renderEmail());
  },
  renderInactiveState: function renderInactiveState() {
    var NotFoundMarker = this.props.NotFoundMarker;
    return _react.default.createElement(_UIErrorMessage.default, {
      type: "notFound",
      title: this.renderHeader('error.downgraded.header')
    }, this.renderDescription('error.downgraded.description'), this.renderEmail(), _react.default.createElement(NotFoundMarker, null));
  },
  renderLinkNotFound: function renderLinkNotFound() {
    var NotFoundMarker = this.props.NotFoundMarker;
    return _react.default.createElement(_UIErrorMessage.default, {
      className: "link-not-found",
      type: "notFound",
      title: this.renderHeader('error.general.header')
    }, this.renderDescription('error.general.genericDescription'), _react.default.createElement(NotFoundMarker, null));
  },
  renderError: function renderError() {
    var ErrorMarker = this.props.ErrorMarker;
    return _react.default.createElement(_UIErrorMessage.default, null, this.renderDescription('error.general.errorDescription'), _react.default.createElement(ErrorMarker, null));
  },
  renderDifferentMessages: function renderDifferentMessages() {
    var _this$props = this.props,
        meetingCreationFailed = _this$props.meetingCreationFailed,
        bookInfoFailed = _this$props.bookInfoFailed,
        bookInfoError = _this$props.bookInfoError,
        meetingsUserFetchSuccess = _this$props.meetingsUserFetchSuccess;

    if (meetingCreationFailed) {
      return this.renderCreateErrorWithReload();
    }

    if (bookInfoFailed && (bookInfoError === _errors.NOT_FOUND || bookInfoError === _errors.USER_NOT_FOUND)) {
      if (meetingsUserFetchSuccess) {
        return this.renderInactiveState();
      }

      return this.renderLinkNotFound();
    }

    return this.renderError();
  },
  render: function render() {
    return _react.default.createElement("div", {
      className: "meetings-error text-center"
    }, this.renderDifferentMessages());
  }
});

exports.default = _default;
module.exports = exports.default;